export function readCSSVars(element, vars) {

    const cs = getComputedStyle(element);
    const out = {};

    vars.forEach(v => {
        out[v] = parseFloat(cs.getPropertyValue(v));
    });

    return out;

}

export function getCSSProperty(element, property) {

    const cs = getComputedStyle(element);

    return cs.getPropertyValue(property);
   
}

export function applyCSSVars(element, values) {

    for (const key in values) {

        element.style.setProperty(key, values[key]);

    }

}
